import type { WizardFlowDefinition } from '../flowTypes';
import ConsentStartStep from '../../components/consent/ConsentStartStep';
import ConsentCustodyStep from '../../components/consent/ConsentCustodyStep';
import ConsentSelectChildStep from '../../components/consent/ConsentSelectChildStep';
import ConsentEnterChildStep from '../../components/consent/ConsentEnterChildStep';
import ConsentGivePermissionStep from '../../components/consent/ConsentGivePermissionStep';
import ConsentConfirmationStep from '../../components/consent/ConsentConfirmationStep';
import GdprStep from '../../components/shared/GdprStep';

const pasConsentPhases = [
  { id: 'intro', name: 'Start' },
  { id: 'consent', name: 'Samtykke' },
  { id: 'confirmation', name: 'Afslut' }
] as const;

const pasConsentFlow: WizardFlowDefinition = {
  id: 'pas_samtykke',
  startStep: 'consent_start',
  phases: pasConsentPhases,
  steps: {
    consent_start: { id: 'consent_start', name: 'Samtykke', component: ConsentStartStep, next: 'gdpr', phase: 'intro' },
    gdpr: { id: 'gdpr', name: 'GDPR', component: GdprStep, next: 'consent_custody', phase: 'intro' },
    consent_custody: {
      id: 'consent_custody',
      name: 'Forældremyndighed',
      component: ConsentCustodyStep,
      next: 'consent_select_child',
      phase: 'consent'
    },
    consent_select_child: {
      id: 'consent_select_child',
      name: 'Vælg barn',
      component: ConsentSelectChildStep,
      getNext: (data) => {
        if (data.consentManualChild === true || (!data.consentChildName?.trim() && !data.consentChildCpr?.trim())) {
          return 'consent_enter_child';
        }
        return 'consent_give';
      },
      validate: (data) => {
        if (data.consentManualChild === undefined && !data.consentChildName?.trim() && !data.consentChildCpr?.trim()) {
          return 'Vælg barn eller vælg "Et andet barn".';
        }
        return null;
      },
      phase: 'consent'
    },
    consent_enter_child: { id: 'consent_enter_child', name: 'Angiv barn', component: ConsentEnterChildStep, phase: 'consent' },
    consent_give: {
      id: 'consent_give',
      name: 'Giv samtykke',
      component: ConsentGivePermissionStep,
      next: 'consent_confirmation',
      validate: (data) => (data.consentGiven ? null : 'Bekræft venligst samtykke.'),
      phase: 'consent'
    },
    consent_confirmation: {
      id: 'consent_confirmation',
      name: 'Bekræftelse',
      component: ConsentConfirmationStep,
      phase: 'confirmation'
    }
  }
};

export { pasConsentFlow };

